module.exports = __webpack_public_path__ + "img/local-icon.48867d6c.svg";